import { createFileRoute } from '@tanstack/react-router';

import { ClaireRegressionsPage } from '@/features/admin-terminal/components/claire-regressions';

/** Is Claire getting better live, which fix did it, and the replay test runs (ENG-2029). */
export const Route = createFileRoute('/_admin/admin/claire-regressions')({
  component: ClaireRegressionsPage,
});
